module.exports = __webpack_public_path__ + "img/1480075104.9022f40d.jpg";